import { useMemo } from "react";
import type { ProductVariation } from "@/types/productVariations";
import { StockStatus } from "@/types/products";

type UseInStockVariationsReturn = ProductVariation[];

/**
 * 判斷變體是否有庫存且可購買 helper
 */
const isStockAvailable = (variation: ProductVariation) => {
  const isPurchasable = variation?.purchasable;
  const isInStock = variation?.stock_status === StockStatus.InStock;
  const hasSufficientStock = variation?.manage_stock ? (variation?.stock_quantity ?? 0) > 0 : true;

  return isPurchasable && isInStock && hasSufficientStock;
};

/**
 * 過濾有庫存的變體
 * 職責：從所有變體中過濾出有庫存且可購買的變體，並依 id 排序
 */
const useInStockVariations = (
  stockedVariations: ProductVariation[] | null,
): UseInStockVariationsReturn => {
  const inStockVariations = useMemo(() => {
    if (!stockedVariations) return [];

    return stockedVariations.filter(isStockAvailable).sort((a, b) => a.id - b.id);
  }, [stockedVariations]);

  return inStockVariations;
};

export default useInStockVariations;
